<template>
  <div class="store-list-w" v-if="hasStore">
    <label>选择门店：</label>
    <a-select
      ref="select"
      placeholder="请选择"
      @change="handleChange"
      class="store-list"
      size="large"
      :default-value="defaultValue"
    >
      <a-select-option
        v-for="d in list"
        :key="d.businessId"
        :title="d.storeName"
      >
        {{ d.storeName }}
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
import { getStoreList } from "../services";
import { Select } from "ant-design-vue";
import { MIN_SAFE_INTEGER } from "../constants";
const { Option } = Select;
const emptyStore = {
  businessId: MIN_SAFE_INTEGER,
  storeId: MIN_SAFE_INTEGER,
  storeName: "请选择门店"
};
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      hasStore: false,
      /**@type Array<import('../services').storeInfo> */
      list: [],
      defaultValue: null
    };
  },
  async created() {
    let data = await getStoreList();
    this.hasStore = !!data.toStore;
    this.list = data.storeList;
    if (this.list.length === 1) {
      let val = this.list[0].businessId;
      this.defaultValue = val;
      this.handleChange(val);
    }
    this.list.unshift(emptyStore);
    if (this.list.length > 2) {
      this.defaultValue = MIN_SAFE_INTEGER;
      this.handleChange(MIN_SAFE_INTEGER);
    }
  },
  methods: {
    handleChange(val) {
      const { hasStore: useStore } = this;
      console.log(val);
      if (+val === MIN_SAFE_INTEGER) {
        this.$emit("storeSelected", {
          storeInfo: emptyStore,
          useStore
        });
      } else {
        this.$emit("storeSelected", {
          storeInfo: this.list.find(x => +x.businessId === +val),
          useStore
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.store-list-w {
  display: flex;
  align-items: center;
  & label {
    font-size: 16px;
  }
}
.store-list {
  width: 300px;
  height: 50px;
  border: 1px solid #e2e2e2;
  margin-right: 20px;
  /deep/ .ant-select-selection.ant-select-selection--single {
    border: 0;
    height: 100%;
    font-size: 18px;
    .ant-select-selection__rendered {
      height: inherit;
      .ant-select-selection-selected-value {
        height: inherit;
        line-height: 48px;
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .store-list {
    width: 200px;
  }
}
</style>
